// TestimoniesCarousel.tsx
"use client";
import React, { useState } from "react";
import { AudioLines, Tv, Notebook } from "lucide-react";

import AudioTestimonies from "./audio/AudioTestimonies";
import VideoTestimonies from "./video/VideoTestimonies";
import WrittenTestimonies from "./written/WrittenTestimonies";
import "./TestimoniesCarousel.css";

type Slide = {
  component: React.ComponentType<{ isActive?: boolean }>;
  icon: React.ReactNode;
  label: string;
};

const TestimoniesCarousel = () => {
  const slides: Slide[] = [
    { component: AudioTestimonies, icon: <AudioLines size={20} />, label: "Audio" },
    { component: VideoTestimonies, icon: <Tv size={20} />, label: "Video" },
    { component: WrittenTestimonies, icon: <Notebook size={20} />, label: "Written" },
  ];

  const [currentSlide, setCurrentSlide] = useState(1);

  return (
    <div className="t-carousel-container tl-indicator-aurora">
        <div className="t-carousel-slides" role="region" aria-label="Testimonies Carousel">
          <div
            className="t-carousel-inner"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {slides.map((slide, index) => {
              const Comp = slide.component;
              const active = currentSlide === index;
              return (
                <div
                  key={index}
                  className="t-carousel-slide"
                  aria-hidden={!active}
                >
                  <Comp isActive={active} />
                </div>
              );
            })}
          </div>
        </div>

        <div className="testimony-carousel-indicators" role="tablist" aria-label="Select testimony tab">
          <div className="indicators-container"> 
            {slides.map((slide, index) => {
              const active = currentSlide === index;
              return (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`indicator ${active ? "active" : ""}`}
                  role="tab"
                  aria-selected={active}
                  aria-controls={`slide-${index}`}
                  tabIndex={active ? 0 : -1}
                  title={slide.label}
                >
                  {slide.icon}
                </button>
              );
            })}
          </div>
        </div>
      </div>
  );
};

export default TestimoniesCarousel;
